import * as R from "ramda";
import { latinAlphabet, latinVowels } from "../shared";

const extraVowels = ["ü", "ö", "ä"];

// TODO: Check if "y" has a red color in german workbooks.
export const vowels_de_DE = R.concat(latinVowels, extraVowels);

export const alphabet_de_DE = [...latinAlphabet];
